import apiClient from "../config/apiClient";


export const fetchDepartments = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=departments`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
